export const getScrollbarWidth = () =>
  typeof window !== 'undefined' && window.innerWidth - document.documentElement?.clientWidth
